import React from "react";
import { motion } from "framer-motion/dist/framer-motion";

import {
  divVariants,
  logoExitVariants,
  bounce_right_to_left_variants,
  bounce_exit_left_variants
} from "shared/components/animations";
import promptIcon from "assets/images/gah/prompt.png";
import bannerLogo from "assets/images/gah/others-banner.png";
import rectSmall from "assets/images/gah/rectangle-small.png";

const PlayingActive = ({ prompt }) => {
  return (
    <motion.div
      variants={divVariants}
      initial="hidden"
      animate="visible"
      exit="exit"
      className="playing-active"
    >
      <motion.div
        variants={logoExitVariants}
        className="top-lobby-banner active"
      >
        <img alt="" src={rectSmall} className="banner-icon" />
        <h2>You're in Charge!</h2>
        <img alt="" src={promptIcon} className="prompt" />
      </motion.div>

      <motion.div
        variants={bounce_right_to_left_variants}
        className="banner-playing"
      >
        <img alt="" src={bannerLogo} />
        <h2 className="banner-text">READ THE CARD ALOUD</h2>
      </motion.div>

      <motion.div
        variants={bounce_exit_left_variants}
        className="question-div flipInY"
      >
        <div className="border-div" />
        <div className="active-playing-div">
          <h2 className="primary-text">{prompt}</h2>
        </div>
      </motion.div>
    </motion.div>
  );
};

export default PlayingActive;
